import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function sessionReducer(state = initialState.session, action) {
  switch(action.type) {
    case types.PERSIST_USER:
      let token = sessionStorage.getItem('token')
      return {
        ...state,
        active: token === null || token === undefined ? false : true
      }
    case types.LOG_OUT:
      sessionStorage.removeItem('token')
      return {
        ...state,
        active: false
      }
    case types.LOG_IN_SUCCESS:
      sessionStorage.setItem('token', action.res.token);
      return {
        ...state,
        ...action.res,
        active: true
      }
    case types.LOG_IN_FAILED:
      return {
        ...state,
        code: action.code,
        message: action.message
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sessionReducer.js